<script setup>
import steps from './steps'
import wrapper from './sla/sla.vue'
import { inject } from 'vue'

const stepNames = Object.keys(steps)
const complaint = inject('complaint')
// @todo возможное дублирование значения переменных editables/leap-steps
defineProps(['editables', 'flowstep', 'closed', 'leapSteps'])
</script>
<template>
  <div class="nav nav-tabs complaint-steps">
    <div class="nav-item" v-for="(s, i) of stepNames" :key="s">
      <wrapper #="{ sla }" :step="s" :complaint="complaint">
        <RouterLink
          class="step nav-link"
          :class="{
            [`sla-${sla.color}`]: true,
            'sla-started': sla.started || s == 'registration',
            'sla-finished': sla.finished,
            flow: flowstep == s,
            done: closed,
            skip: !leapSteps[s],
            active: $route.params.step ? $route.params.step == s : s == 'registration',
          }"
          :to="
            $route.params.id
              ? { name: 'complaint.item.step', params: { id: $route.params.id, step: s } }
              : { name: 'complaint.create' }
          "
          :replace="true"
        >
          {{ steps[s].title }}
        </RouterLink>
      </wrapper>
    </div>
  </div>
</template>
